import {BaseApiRequestParams} from "../../../../infrastructure/models/params/base-api-request-params";

export class LocaleRequestParams extends BaseApiRequestParams {
  cultureName: String;

  constructor(cultureName: String) {
    super('locale/');

    this.cultureName = cultureName;
  }
}
